var map = {
	"./cn/小学/wap.svg": "2x+t",
	"./en/小学/wap.svg": "VI7V"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "44HI";


//////////////////
// WEBPACK FOOTER
// ./src/assets ^\.\/.*\/小学\/wap\.svg$
// module id = 44HI
// module chunks = 16